import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const softwares = createReducer(
  {
    info: {},
    status: null,
    isVerified: null,
    isRequested: null,
    isActivated: null,
    isApproved: null,
    isDeclined: null,
    selectedSoftware: null,
    isSoftwareSelected: null,
    isIntegrated: true,
    bookerClientId: '',
    bookerClientSecret: '',
    otherUsername: '',
    otherPassword: '',
    bookerAccountInfo: {},
    getBookingSoftwareLocations: false,
    bookingSoftwareLocations: [],
    isZenotiConfigureSetup: false,
    isZenotiReferral: false,
    zenotiData: {},
    meevoData: {},
    brand: false,
    brand_ids: [],
    form: {},
    LOGIN: '',
    PASSWORD: '',
    isAuthError: false,
    getSoftwares: false,
  },
  {
    [types.GET_SOFTWARES_START](state) {
      const newState = Object.assign({}, state, {
        info: Object.assign(
          {
            isLoaded: false,
          },
          state.info,
        ),
        getSoftwares: true,
      });

      return newState;
    },

    [types.GET_SOFTWARES_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        selectedSoftware: action.info.BOOKING_VENDOR_ID || '',
        bookerClientId: action.info.SITE_ID || '',
        bookerClientSecret: action.info.BOOKER_CLIENT_SECRET || '',
        isOtherSoftware: !!action.info.NEW_BOOKING_SW,
        otherUsername: action.info.LOGIN,
        otherPassword: action.info.PASSWORD,
        studioId: action.info.SITE_ID || '',
        brand: action.info.brand,
        brand_ids: action.info.brand_ids,
        form: action.info.form,
        LOGIN: action.info.LOGIN || '',
        bsw_id: action.info.id || '',
        PASSWORD: action.info.PASSWORD || '',
        info: Object.assign(
          {
            isLoaded: true,
          },
          action.info,
        ),
        status: action.info.STATUS,
        is_truelark: action.info?.is_truelark,
        requestStatusMessage: null,
        getSoftwares: false,
      });

      return newState;
    },
    [types.GET_SOFTWARES_FAIL](state) {
      const newState = Object.assign({}, state, {
        info: {
          isLoaded: true,
        },
        getSoftwares: false,
      });

      return newState;
    },
    [types.RESET_SELECTED_SOFTWARE](state) {
      const newState = Object.assign({}, state, {
        isSoftwareSelected: null,
      });

      return newState;
    },
    [types.SET_SOFTWARES_RESET](state) {
      const newState = Object.assign({}, state, {
        isSoftwareSaved: null,
        mindbodyActivationCode: '',
        mindbodyActivationLink: '',
        bookerClientId: '',
        bookerClientSecret: '',
        otherUsername: '',
        otherPassword: '',
      });

      return newState;
    },
    [types.SET_SOFTWARES_SUCCESS](state, action) {
      const newState = Object.assign({}, state, action.software, {
        isSoftwareSaved: true,
        mindbodyActivationCode: action.activationCode,
        mindbodyActivationLink: action.activationLink,
      });

      return newState;
    },
    [types.SET_SOFTWARES_FAIL](state) {
      const newState = Object.assign({}, state, {
        isSoftwareSaved: false,
        studioId: '',
        mindbodyActivationCode: '',
        mindbodyActivationLink: '',
        bookerClientId: '',
        bookerClientSecret: '',
        otherUsername: '',
        otherPassword: '',
      });

      return newState;
    },
    [types.GET_STUDIO_ID_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        studioIdMB: action.studioId,
      });

      return newState;
    },
    [types.GET_STUDIO_ID_FAIL](state) {
      const newState = Object.assign({}, state, {
        studioIdMB: '',
      });

      return newState;
    },
    [types.BOOKING_SOFTWARE_SELECTED](state, action) {
      const newState = Object.assign({}, state, {
        selectedSoftware: action.software,
        isSoftwareSelected: true,
        isSoftwareSaved: false,
        isIntegrated: false,
      });

      return newState;
    },
    [types.RESET_BOOKING_SOFTWARE_SELECTED](state) {
      const newState = Object.assign({}, state, {
        isSoftwareSelected: false,
        isSoftwareSaved: false,
        isIntegrated: true,
      });

      return newState;
    },
    [types.GET_SOFTWARE_ACTIVATION_START](state) {
      const newState = Object.assign({}, state, {
        isActivated: null,
      });

      return newState;
    },
    [types.GET_SOFTWARE_ACTIVATION_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        isActivated: true,
      });

      return newState;
    },
    [types.GET_SOFTWARE_ACTIVATION_FAIL](state) {
      const newState = Object.assign({}, state, {
        isActivated: false,
      });

      return newState;
    },
    [types.RESET_BOOKING_SOFTWARE_SETUP](state) {
      const newState = Object.assign({}, state, {
        isCompleteSetup: null,
      });

      return newState;
    },
    [types.COMPLETE_BOOKING_SOFTWARE_SETUP](state) {
      const newState = Object.assign({}, state, {
        isCompleteSetup: true,
      });

      return newState;
    },
    [types.VERIFY_BOOKING_SOFTWARE_START](state) {
      const newState = Object.assign({}, state, {
        isVerified: null,
      });

      return newState;
    },
    [types.VERIFY_BOOKING_SOFTWARE_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        isVerified: true,
      });

      return newState;
    },
    [types.VERIFY_BOOKING_SOFTWARE_FAIL](state) {
      const newState = Object.assign({}, state, {
        isVerified: false,
      });

      return newState;
    },
    [types.REQUEST_BOOKING_SOFTWARE_START](state) {
      const newState = Object.assign({}, state, {
        isRequested: null,
        isSavingStaffCredentials: true,
        staffCredSaved: false,
        staffCredentialsSaveFail: false,
      });

      return newState;
    },
    [types.REQUEST_BOOKING_SOFTWARE_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        isRequested: true,
        staffCredSaved: true,
        requestStatusMessage: action.message,
        isSavingStaffCredentials: false,
      });

      return newState;
    },
    [types.REQUEST_BOOKING_SOFTWARE_FAIL](state) {
      const newState = Object.assign({}, state, {
        isRequested: false,
        requestStatusMessage:
          'Authorization failed. Please retry with correct credentials!',
        isSavingStaffCredentials: false,
        staffCredentialsSaveFail: true,
        staffCredSaved: false,
      });

      return newState;
    },
    [types.APPROVE_BOOKING_SOFTWARE_ACCESS_START](state) {
      const newState = Object.assign({}, state, {
        isApproved: null,
      });

      return newState;
    },
    [types.APPROVE_BOOKING_SOFTWARE_ACCESS_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        isApproved: true,
      });

      return newState;
    },
    [types.APPROVE_BOOKING_SOFTWARE_ACCESS_FAIL](state) {
      const newState = Object.assign({}, state, {
        isApproved: false,
      });

      return newState;
    },
    [types.DECLINE_BOOKING_SOFTWARE_ACCESS_START](state) {
      return Object.assign({}, state, {
        isDeclined: null,
      });
    },
    [types.DECLINE_BOOKING_SOFTWARE_ACCESS_SUCCESS](state) {
      return Object.assign({}, state, {
        isDeclined: true,
      });
    },
    [types.DECLINE_BOOKING_SOFTWARE_ACCESS_FAIL](state) {
      return Object.assign({}, state, {
        isDeclined: false,
      });
    },
    [types.POST_BOOKER_ACCOUNT_INFO_START](state) {
      return {
        ...state,
        isSavingBookerAccountInfo: true,
        isBookerAccountInfoSaveSuccess: false,
        isBookerAccountInfoSaveFail: false,
      };
    },
    [types.POST_BOOKER_ACCOUNT_INFO_SUCCESS](state, action) {
      return {
        ...state,
        isSavingBookerAccountInfo: false,
        isBookerAccountInfoSaveSuccess: true,
        bookerAccountInfo: action.data,
      };
    },
    [types.POST_BOOKER_ACCOUNT_INFO_FAIL](state) {
      return {
        ...state,
        isSavingBookerAccountInfo: false,
        isBookerAccountInfoSaveFail: true,
      };
    },
    [types.BOOKER_EMAIL_SEND_RESET](state) {
      return {
        ...state,
        isBookerEmailSendSuccess: false,
      };
    },
    [types.BOOKER_EMAIL_SEND_SUCCESS](state) {
      return {
        ...state,
        isBookerEmailSendSuccess: true,
      };
    },
    [types.POST_ZENOTI_CONFIGURE_SETUP](state) {
      return {
        ...state,
        isZenotiConfigureSetup: true,
        isZenotiAutorized: false,
      };
    },
    [types.POST_ZENOTI_REFERRAL](state) {
      return {
        ...state,
        isZenotiReferral: true,
        isZenotiAutorized: false,
      };
    },
    [types.POST_ZENOTI_ACCOUNT_INFO_START](state) {
      return {
        ...state,
        isSavingZenotiAccountInfo: true,
        isZenotiAccountInfoSaveSuccess: false,
        isZenotiAccountInfoSaveFail: false,
        isZenotiAutorized: false,
      };
    },
    [types.POST_ZENOTI_ACCOUNT_INFO_SUCCESS](state) {
      return {
        ...state,
        isSavingZenotiAccountInfo: false,
        isZenotiAccountInfoSaveSuccess: true,
        isZenotiAccountInfoSaveFail: false,
        isZenotiAutorized: false,
        isAuthError: false,
      };
    },
    [types.POST_ZENOTI_ACCOUNT_INFO_FAIL](state, action) {
      console.log('ACTION12', action);
      const errorMessage = action?.errorBody?.message || '';
      return {
        ...state,
        isSavingZenotiAccountInfo: false,
        isZenotiAccountInfoSaveSuccess: false,
        isZenotiAccountInfoSaveFail: true,
        isZenotiAutorized: false,
        isAuthError: action.isAuthError,
        errorMessage,
      };
    },
    [types.POST_ZENOTI_AUTHORIZATION_START](state) {
      return {
        ...state,
        isZenotiAutorization: true,
      };
    },
    [types.POST_ZENOTI_AUTHORIZATION_FAIL](state) {
      return {
        ...state,
        isZenotiAutorized: false,
        isZenotiAutorization: false,
        isZenotiAutorizationFail: true,
        isRequested: false,
        requestStatusMessage:
          'Authorization failed. Please retry with correct credentials!',
      };
    },
    [types.POST_ZENOTI_AUTHORIZATION_SUCCESS](state) {
      return {
        ...state,
        isZenotiAutorized: true,
        isZenotiAutorization: false,
      };
    },
    [types.AUTH_FLAG_CLEAR](state) {
      return {
        ...state,
        isZenotiAutorizationFail: false,
      };
    },
    [types.POST_ZENOTI_STAFF_LOGIN_START](state) {
      return {
        ...state,
        isZenotiStaffLogin: true,
        zenotiStaffCredLogin: false,
      };
    },
    [types.POST_ZENOTI_STAFF_LOGIN_SUCCESS](state) {
      return {
        ...state,
        isZenotiStaffLogin: false,
        zenotiStaffCredLogin: true,
      };
    },
    [types.POST_ZENOTI_STAFF_LOGIN_FAIL](state) {
      return {
        ...state,
        isZenotiStaffLogin: false,
        zenotiStaffCredLogin: false,
      };
    },
    [types.GET_BOOKING_SOFTWARE_LOCATIONS_START](state) {
      return {
        ...state,
        getBookingSoftwareLocations: true,
      };
    },
    [types.GET_BOOKING_SOFTWARE_LOCATIONS_SUCCESS](state, actions) {
      return {
        ...state,
        getBookingSoftwareLocations: false,
        bookingSoftwareLocations: actions.locations,
      };
    },
    [types.GET_BOOKING_SOFTWARE_LOCATIONS_FAIL](state) {
      return {
        ...state,
        getBookingSoftwareLocations: false,
        bookingSoftwareLocations: [],
      };
    },
    [types.STORE_ZENOTI_DATA](state, action) {
      return {
        ...state,
        zenotiData: { ...state.zenotiData, ...action.data },
      };
    },
    [types.STORE_MEEVO_DATA](state, action) {
      return {
        ...state,
        meevoData: { ...state.meevoData, ...action.data },
      };
    },
  },
);

export { softwares as default };
